import React from "react";

const FigmaFrame = ({ url }) => {
  return (
    <div>
      <iframe
        title="Figma design preview"
        style={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
        className="FigmaFrame"
        height="550px"
        src={url}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default FigmaFrame;
